





















import { Component, Vue, Prop } from "vue-property-decorator";
import LoginCollection from "@/components/login/LoginCollection.vue";
import LoginDescriptionCard from "@/components/login/LoginDescriptionCard.vue";

@Component({
  components: { LoginCollection, LoginDescriptionCard }
})
export default class LoginCard extends Vue {
  @Prop({})
  onLogin!: Function;
  @Prop({ default: "logo" })
  logo!: string;
  @Prop({ default: "title" })
  title!: string;
  @Prop({ default: "text" })
  text!: string;
  @Prop({ default: false })
  isDescriptionCardActive?: boolean;
  @Prop({ default: false })
  showLogoOnMobile?: boolean;

  onLoginFunction =
    this.onLogin ||
    (() => {
      window.alert("logged in");
    });
}
